import { Box, Typography, Card, CardContent, Chip } from "@mui/material";
import React from "react";

import { useCelleraTheme } from "../../../../theme/useCelleraTheme";
import SectionWrapper from "./SectionWrapper";

export interface Appointment {
  id: string;
  title: string;
  time: string;
  date: string;
  doctor: string;
  status: "Pending" | "Completed" | "Cancelled";
}

interface AppointmentsProps {
  appointments: Appointment[];
  onViewAll: () => void;
}

const Appointments: React.FC<AppointmentsProps> = ({
  appointments,
  onViewAll,
}) => {
  const { colors } = useCelleraTheme();

  return (
    <SectionWrapper title="Appointments" onViewAll={onViewAll}>
      {appointments.map((appointment) => (
        <Card
          key={appointment.id}
          sx={{
            borderRadius: 2,
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  className="font-medium text-xs leading-4 tracking-wider border-b border-gray-200"
                  sx={{
                    color: colors.text.primary,
                  }}
                >
                  {appointment.title}
                </Typography>
                <Typography
                  className="font-normal text-xs leading-4 tracking-wide"
                  sx={{
                    color: colors.text.secondary,
                  }}
                >
                  {appointment.time} {appointment.date}
                </Typography>
                <Typography
                  className="font-normal text-xs leading-4 tracking-wide"
                  sx={{
                    color: colors.text.secondary,
                  }}
                >
                  Doctor: {appointment.doctor}
                </Typography>
              </Box>
              <Chip
                label={appointment.status}
                size="small"
                className="h-8 min-w-[75px] text-sm font-medium leading-5 tracking-wide bg-white py-0.5"
                sx={{
                  border: "1px solid #D1D5DB",
                  borderRadius: "8px",
                  "& .MuiChip-label": {
                    px: 2,
                    py: 0.5,
                  },
                }}
              />
            </Box>
          </CardContent>
        </Card>
      ))}
    </SectionWrapper>
  );
};

export default Appointments;
